import { encrypt } from '@/common/securityUtils';

export const statusTypeMap: Record<string, string> = {
  list: '1',
  request: '2',
};

export const encryptedStatusTypeMap: Record<string, string> = Object.fromEntries(
  Object.entries(statusTypeMap).map(([type, encryptedValue]) => [type, encrypt(encryptedValue)]),
);
